// removed by extract-text-webpack-plugin
module.exports = {"box":"_1wgVlCxJYMLRsOgOjipUeB"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/BoxShadow/style.css
// module id = 250
// module chunks = 101